import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Category } from 'src/app/entities/category';
import { CategoryService } from 'src/app/services/category.service';
import { CartService } from 'src/app/services/cart.service';
import { CartItem } from 'src/app/entities/cart-item';
import { AuthenticationService, MIAUser } from '@mobileia/authentication';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  @ViewChild(MatMenuTrigger) public menuTrigger: MatMenuTrigger;

  categories = new Array<Category>();
  cart = new Array<CartItem>();
  currentUser = new MIAUser();

  sectionActive = 0;
  navbarMobileActive:boolean = true;
  menuOpen:boolean = true;
  navbarFixedTop:boolean = true;

  // Icon Menu Navbar
  jamMenu:string = "jam-menu";
  jamClose:string = "jam-close";

  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  options: string[] = [];
  searchInput = '';

  constructor(
    protected categoryService: CategoryService,
    protected cartService: CartService,
    protected authService: AuthenticationService,
    protected navigator: Router,
    protected route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.loadCategories();
    this.loadCart();
    this.loadUser();
    this.loadSearch();

    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  onLogout() {
    this.authService.signOut();
    this.currentUser = new MIAUser();
    this.navigator.navigateByUrl('/');
  }

  loadUser() {
    this.authService.currentUser.subscribe(data => {
      if (data == null) {
        return;
      }
      this.currentUser = data;
      if (this.menuTrigger) {
        this.menuTrigger.closeMenu();
      }
    });
  }

  loadCart() {
    this.cartService.items.subscribe(data => {
      this.cart = data;
    });
  }

  loadCategories() {
    this.categoryService.fetchAll().toPromise().then(data => {
      if (data.success) {
        this.categories = data.response;
      }
    });
  }

  loadSearch() {
    this.route.queryParams.subscribe(params => {
      if (params.search) {
        this.searchInput = params.search;
      }
    });
  }

  onSearch(event) {
    this.navigator.navigateByUrl('/buscar-producto?search=' + this.searchInput);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  clickSection(section) {
    this.sectionActive = section;
  }

  stopPropagation(event){
    event.stopPropagation();
  }
}
